import { Card, FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { FormFieldsEdit, FormFieldsView } from '../../../../types/form-types'
import useUser from '../../../hooks/use-user'
import { isCouncilUserOrAdmin, isDriller } from '../../../services/user-utils'

interface WellDetailsOwnerCardViewProps {
  isLoading: boolean
  fields: Partial<FormFieldsView | FormFieldsEdit>
}
export default function WellDetailsOwnerCardView({ isLoading, fields }: WellDetailsOwnerCardViewProps) {
  const { user } = useUser()
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        Owner
      </Heading>
      <FormField isSkeleton={isLoading} labelId='ownerType' label='Owner type'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='ownerType' value={`${fields.ownerType ?? ''}`} />
      </FormField>
      {(isDriller(user) || isCouncilUserOrAdmin(user)) && (
        <FormField isSkeleton={isLoading} labelId='ownerName' label='Owner name'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='ownerName' value={`${fields.ownerName ?? ''}`} />
        </FormField>
      )}
      {isCouncilUserOrAdmin(user) && (
        <FormField
          toolTipMessage={TOOLTIP.customerReferenceNo}
          isSkeleton={isLoading}
          labelId='customerReferenceNo'
          label='Customer reference number'
        >
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='customerReferenceNo'
            value={`${fields.customerReferenceNo ?? ''}`}
          />
        </FormField>
      )}
    </Card>
  )
}
